module.exports = __webpack_public_path__ + "img/CotacoesMenu.1d7cd751.png";